






























































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'

settings =
  name: 'LineItem'

  vue:
    props: ['lineItem', 'actions'],
    components: { LoadingIndicator }

    data: ->
      searchTime: null

    computed:
      isOmnichannel: -> @lineItem.pricing_model is 'omnichannel'
      isDiscounted: -> @lineItem.original_price_in_dollars isnt @lineItem.price_in_dollars
      quantityImmutable: -> ['video_wall', 'addon_serve_cold'].includes @lineItem.pricing_model

    methods:
      eventForLineItem: (lineItem)-> @ctxEvent lineItem
      spaceFor: (lineItem) -> @eventForLineItem(lineItem)?.spaces[lineItem.space_name]
      spaceTypeFor: (lineItem) -> @spaceFor(lineItem)?.type

      debounce: (cb, time = 300) ->
        clearTimeout @searchTime
        @searchTime = setTimeout cb, time

      hiUpdateQuantity: -> # Trigger only number is pressed
        @debounce(() => @actions.hiUpdateQuantity(@lineItem))

export default VueOptions.vue settings
